/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A18Inputs */

const et_faq_a18 = /** @type {(inputs: Faq_A18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hea turundusagentuur mõõdab oma tulemusi päringute ja müügi, mitte ainult klikkide ja näitamiste järgi. Ta ühendab veebilehe, SEO, sisustrateegia ja automaatika ühtseks kliendihankesüsteemiks, mitte üksikute kanalitena. ScalingWebs töötab just sellise mudeliga: sihime ärilist tulemust, mitte tegevuste nimekirja. Hea agentuur on partner, kes riskib koos sinuga — nagu meie garanteeritud tulemuste mudel seda kajastab.`)
};

const en_faq_a18 = /** @type {(inputs: Faq_A18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A good marketing agency measures results by inquiries and sales, not just clicks and impressions. It connects your website, SEO, content strategy, and automation into one customer acquisition system — not siloed channels. ScalingWebs works exactly this way: we aim for business outcomes, not activity lists. A good agency takes risks alongside you — as our guaranteed results model reflects.`)
};

/**
* | output |
* | --- |
* | "A good marketing agency measures results by inquiries and sales, not just clicks and impressions. It connects your website, SEO, content strategy, and automa..." |
*
* @param {Faq_A18Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a18 = /** @type {((inputs?: Faq_A18Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A18Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a18(inputs)
	return en_faq_a18(inputs)
});